// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Constants
import { INSTAGRAM, FACEBOOK } from 'constants/socialProviders'

// Atoms
import Link from 'atoms/Link'

// Icons
import facebookSvg from 'assets/icons/facebook.svg'
import instagramSvg from 'assets/icons/instagram.svg'

// Components
import StepSpacer from './StepSpacer'
import StepButtonIcon from './StepButtonIcon'
import StepTitle from './StepTitle'

// Styles
const styles = theme => ({
  or: {
    fontFamily: '"Open Sans", sans-serif',
    fontWeight: 400,
    fontSize: 48 * 0.65,
    color: '#565759',
  },
  container: {
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'center',
    }
  },
  label: {
    color: '#B3B3B1',
    paddingRight: 50 * 0.65,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      marginBottom: 50 * 0.65,
    }
  },
  button: {
    color: '#B3B3B1',
    '&:not(:last-child)': {
      marginRight: 15 * 0.65,
    },
  },
  externalAccLabel: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: 15 * 0.65,
    },
    [theme.breakpoints.up('sm')]: {
      marginRight: 50 * 0.65,
    },
  },
})

export default
@withStyles(styles)
class OnboardingAccountStepSocialAccount extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    externalAcc: PropTypes.object,
  }

  getProviderIcon(provider) {
    return ({
      [INSTAGRAM]: instagramSvg,
      [FACEBOOK]: facebookSvg,
    })[provider]
  }

  renderExternalAccount() {
    const { classes, externalAcc } = this.props
    return (
      <div className={classes.container}>
        <StepTitle secondary className={classes.externalAccLabel}>Complete sign up with</StepTitle>
        <StepButtonIcon
          component={Link}
          to={externalAcc.externaLUserLink}
          external
          target="_blank"
          icon={this.getProviderIcon(externalAcc.provider)}
        >
          { externalAcc.externalUserName || `${externalAcc.firstName} ${externalAcc.lastName}` }
        </StepButtonIcon>
      </div>
    )
  }

  renderLinks() {
    const { classes } = this.props
    const providers = [
      { url: '/api/v1/social/facebook/signup', icon: this.getProviderIcon(FACEBOOK) },
      { url: '/api/v1/social/instagram/signup', icon: this.getProviderIcon(INSTAGRAM) },
    ]
    return (
      <Fragment>
        <div className={classes.or}>or</div>
        <StepSpacer small />
        <div className={classes.container}>
          <StepTitle secondary className={classes.label}>Sign up with</StepTitle>
          { providers.map(provider => (
            <StepButtonIcon
              key={provider.url}
              icon={provider.icon}
              to={provider.url}
              component={Link}
              external
              className={classes.button}
            />
          )) }
        </div>
      </Fragment>
    )
  }

  render() {
    const { externalAcc } = this.props
    return externalAcc ? this.renderExternalAccount() : this.renderLinks()
  }
}
